import * as React from "react";

import {
  List,
  Datagrid,
  ListProps,
  TextField,
  BooleanField,
  FunctionField, TopToolbar, CreateButton, ExportButton, EditButton, DeleteButton,
  downloadCSV,
  DateField
} from "react-admin";
import { Button } from "@material-ui/core"
import { getTags } from './ProductUtil'
import Pagination from "../Components/Pagination";
import AddIcon from '@material-ui/icons/Add';
// @ts-ignore
import { unparse as convertToCSV } from 'papaparse/papaparse.min';
import {ProductSearch} from "./ProductSearch"

const exporter = (products: any) => {
  const productsForExport = products.map((product: any) => {
    product.tags = getTags(product.meta)
    product.icon = product?.images?.icon
    product.banner = product?.images?.banner
    product.priceSperator = product?.price?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return product;
  });
  const csv = convertToCSV({
    data: productsForExport,
    // select and order fields in the export
    fields: ['title', 'tags', 'priceSperator', 'currency', 'icon', 'banner', 'isEnabled', 'description']
  });
  const BOM = '\uFEFF'
  downloadCSV(`${BOM} ${csv}`, 'products_' + new Date().toLocaleDateString('fa-IR-u-nu-latn').replaceAll('/', '')); // download as 'posts.csv` file
}

const ListActions = (props: any) => (
  <TopToolbar>
    <Button startIcon={<AddIcon style={{ marginLeft: '5px' }} />} className="RaButton-label-7 MuiButton-textSizeSmall" style={{ color: '#20a4f3' }} onClick={() => window.location.href = "#/create-bundle"}>باندل جدید</Button>
    <CreateButton label="جدید" />
    <ExportButton label="خروجی اکسل" />
    {/* Add your custom actions */}
  </TopToolbar>
);

const productType: any = {
  MENTOR: "حامی",
  DIET: "رژیم",
  BUNDLE: "باندل",
  PSYCHOLOGY_SESSION: "روان‌شناسی",
  PARTNER_DISCOUNT: "تخفیف همکار",
  TAG: "دسته بندی",
  PRODUCT: "عادی",
}

export const ProductList = (props: ListProps): React.ReactElement => {
  const [filterList, setFilterList] = React.useState({
      id: { contains: '' },
      title: { contains: '' },
      isEnabled: { equals: true },
      productType: { equals: 'NONE' },
      tags: []
  });

  const showTags = (meta: any): string => {
    let result: string = "";
    meta?.tags?.forEach((tag: any) => {
      let hasLabel = tag?.hasOwnProperty("label")
      if (hasLabel)
        result += tag.label;
      else
        result += tag;
      result = (meta.tags[meta.tags.length - 1] !== tag) ? result + ', ' : result
    })

    return result;
  }
  const EditProductButton = (props: any) => {
    return (
      <EditButton record={props.record} label="ویرایش" />
    )
  };
  return (
    <>
      <ProductSearch filterList={filterList} setFilterList={setFilterList}/>
      <List
        {...props}
        actions={<ListActions />}
        bulkActionButtons={false}
        title={"لیست محصولات"}
        perPage={50}
        pagination={<Pagination />}
        exporter={exporter}
        filter={filterList}
      >
        <Datagrid rowClick="show">
          <TextField label="عنوان" source="title" />
          <TextField label="شناسه" source="id" sortable={false} />
          <FunctionField
            label="نوع محصول"
            source="productType"   
            render={(record: any) => productType[record.productType]}
          />
          {/* <TextField label="توضیحات" source="description" sortable={false} /> */}
          <FunctionField
            label="قیمت"
            render={(record: any) => record.price?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
          />
          <FunctionField
            label="مبلغ تخفیف"
            render={(record: any) => record.offValue?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
          />

          <FunctionField
            label="تگ‌ها"
            render={(record: any) => showTags(record.meta)}
            sortable={false}
          />
          {/* <NumberField source="expiryPeriod" label="تاریخ انقضا سبد خرید" sortable={false} />
          <TextField source="name" label="کد محصول" sortable={false} />
          <TextField label="ایجاد کننده" source="createdBy" sortable={false} /> */}
          <DateField source="createdAt" label="تاریخ ایجاد" locales="fa-IR" /> 
          <BooleanField source="isEnabled" label="فعال" />

          <FunctionField
            label=""
            render={(record: any) => {
              return record.productType === "BUNDLE" ?
                (<Button color="primary" href={`${process.env.REACT_APP_AUTH_PUBLIC_PATH}/#/edit-bundle?id=` + record.id}>ویرایش</Button>) :
                (<Button color="primary" href={`${process.env.REACT_APP_AUTH_PUBLIC_PATH}/#/Product/` + record.id}>ویرایش</Button>)
            }}
          />
          {/* <DeleteButton label="حذف" /> */}
        </Datagrid>
      </List>
    </>
  );
};
